module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-datetime', {
    model: {
      value: (_vm.defaultValue),
      callback: function($$v) {
        _vm.defaultValue = $$v
      },
      expression: "defaultValue"
    }
  }), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("设置2017-04-05")]), _c('br'), _c('br'), _c('p', [_vm._v("显示时分秒")]), _c('vbl-datetime', {
    attrs: {
      "time": ""
    },
    model: {
      value: (_vm.defaultValue1),
      callback: function($$v) {
        _vm.defaultValue1 = $$v
      },
      expression: "defaultValue1"
    }
  }), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.onClick1
    }
  }, [_vm._v("设置2017-04-05 04:05:06")]), _c('br'), _c('br'), _c('p', [_vm._v("时间段")]), _c('vbl-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('vbl-col', {
    attrs: {
      "cols": "11"
    }
  }, [_c('vbl-datetime', {
    attrs: {
      "disable-from": _vm.defaultValue4
    },
    model: {
      value: (_vm.defaultValue3),
      callback: function($$v) {
        _vm.defaultValue3 = $$v
      },
      expression: "defaultValue3"
    }
  })], 1), _c('vbl-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("-")]), _c('vbl-col', {
    attrs: {
      "cols": "11"
    }
  }, [_c('vbl-datetime', {
    attrs: {
      "disable-to": _vm.defaultValue3
    },
    model: {
      value: (_vm.defaultValue4),
      callback: function($$v) {
        _vm.defaultValue4 = $$v
      },
      expression: "defaultValue4"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7637d3f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblDatetime/example/vblDatetimeExample.vue
// module id = 279
// module chunks = 0